import React from 'react';
import { Grid, CircularProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';

import Post from './Post/Post.js';
import useStyles from './styles';

const Posts = () => {
    const posts = useSelector((state) => state.posts).sort((a, b) => {
        return a.createdAt < b.createdAt ? 1: -1
    });

    const classes = useStyles();

    return(
        !posts.length ? <CircularProgress /> : (
            <Grid className={classes.container} container alignItems="stretch" spacing={3}>
                {
                    posts.map((post) => (
                        <Grid key={post._id} item xs={12} md={3} sm={6}>
                            <Post post={post} />
                        </Grid>
                    ))
                }
            </Grid>
        )
    );
}

export default Posts;